import { Modal } from "./modal";

const WithdrawBalance = { Modal };

export default WithdrawBalance;
